export const calculate_combo_price = (selectedServices, servicePrices = {}) => {
    const defaultPrices = {
        meta_ads: 150,
        google_ads: 150,
        social_media_management: 150,
        tiktok_ads: 150,
        email_marketing: 100,
        blog: 100,
        'email journey': 30,
        'profile creation': 30
    };
    const uniqueSelectedServices = [...new Set(selectedServices)];
    const service_price = (serviceName) => {
        return Number(servicePrices[serviceName] ?? defaultPrices[serviceName] ?? 0);
    };
    const standaloneTotal = uniqueSelectedServices.reduce((total, serviceName) => {
        return total + service_price(serviceName);
    }, 0);
    const selectedCount = uniqueSelectedServices.length;
    const highestStandalonePrice = uniqueSelectedServices.reduce((highestPrice, serviceName) => {
        return Math.max(highestPrice, service_price(serviceName));
    }, 0);
    const comboStepPrice = 50;
    let total = standaloneTotal;

    if (selectedCount > 1) {
        total = highestStandalonePrice + (selectedCount - 1) * comboStepPrice;
    }

    if (total > standaloneTotal) {
        total = standaloneTotal;
    }

    const roundedTotal = Number(total.toFixed(2));
    const roundedStandaloneTotal = Number(standaloneTotal.toFixed(2));
    const roundedComboDiscount = Number((roundedStandaloneTotal - roundedTotal).toFixed(2));

    return {
        total: roundedTotal,
        standaloneTotal: roundedStandaloneTotal,
        comboDiscount: roundedComboDiscount
    };
};
